import styled, { css } from 'styled-components'

export const BarButton = styled.button<{
  slimPadding?: boolean
  hasNewTags?: boolean
  darkerHover?: boolean
}>`
  background: transparent;
  border: 0 !important;
  border-radius: var(--border-radius-sm);
  color: var(--color-text-neutral);
  padding: ${(props) => (props.slimPadding ? '10px 0' : '10px')};
  transition: color 0.1s ease-in, background-color 0.1s ease-in;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &.withNewTag {
    margin-right: 10px;
  }

  &.upgrade-plan-cta {
    padding: 6px;
    span {
      margin-left: 0;
    }
  }

  &:hover {
    cursor: pointer;
    color: var(--color-text-neutral);
    background-color: var(--color-bg-a-subtle);
  }

  svg {
    vertical-align: middle;
  }

  :disabled {
    cursor: not-allowed;
    color: var(--color-text-disabled);
    background-color: var(--color-bg-disabled);
  }

  &:after {
    ${(props) =>
      props.hasNewTags &&
      css`
        content: '';
        position: absolute;
        top: 4px;
        right: 4px;
        background-color: #87c221;
        width: 10px;
        height: 10px;
        border-radius: 50%;
      `}
  }
`

export const VerticalDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: var(--color-bg-a-subtle);
  margin: 0 6px;
`

export const IntegrationsWrapper = styled.div`
  padding: 6px 16px;

  position: sticky;
  bottom: -20px;
  background: var(--color-bg-surface-floating);
  z-index: 99999;
  border-radius: 0 0 var(--composer-update-zone-border-radius)
    var(--composer-update-zone-border-radius);

  &.boxed {
    border-top: 1px solid var(--color-border-subtle);
  }
`

export const Emoji = styled.div`
  line-height: 0;
`

export const LeftWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export const RightWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  position: absolute;
  right: 12px;
  top: 19px;
  svg {
    color: var(--color-text-neutral);
  }
`

export const ShortLinkNoticeWrapper = styled.div`
  position: relative;
  line-height: 16px;

  .notice-link-too-short {
    border-radius: 0;
  }
`
